<template lang="html">

  <section class="app-sidebar">
    <nav class="sidebar sidebar-offcanvas " id="sidebar">
      <ul class="nav" >
        <li class="nav-item nav-profile">
          <div class="nav-link">
            <!-- <div class="profile-image"> <img src="../../assets/images/faces/default-profile.jpg" alt="image"/> <span class="online-status online"></span> </div> -->
            <div class="profile-name">
              <h4 class="name">{{ loggedInUser.username }}</h4>
              <div class="badge badge-success mx-auto mt-3">Online</div>
            </div>
          </div>
        </li>
        <li class="nav-item"><router-link class="nav-link" to="/dashboard"><img class="menu-icon" src="../../assets/images/svg_icons/puzzle.svg" alt="menu icon"><span class="menu-title">Dashboard</span></router-link></li>

        <li class="nav-item">
          <span class="nav-link" v-b-toggle="'order-shipping-pages'">
            <img class="menu-icon" src="../../assets/images/svg_icons/in_transit.svg" alt="menu icon"><span class="menu-title">Orders & Shipping</span><i class="menu-arrow"></i>
          </span>
          <b-collapse id="order-shipping-pages">
            <ul class="nav flex-column sub-menu">
              <li class="nav-item"><router-link class="nav-link" to="/orders"><span class="menu-title m-l-25">Manage Orders</span></router-link></li>
              <li class="nav-item"><router-link class="nav-link" to="/dhl-actions"><span class="menu-title m-l-25">DHL Actions</span></router-link></li>
              <li class="nav-item"><router-link class="nav-link" to="/draft-issues"><span class="menu-title m-l-25">Drafts Response</span></router-link></li>
              <li class="nav-item"><router-link class="nav-link" to="/print-queue-and-quality-check"><span class="menu-title m-l-25">Print Queue & QA</span></router-link></li>
            </ul>
          </b-collapse>
        </li>

        <li class="nav-item">
          <span class="nav-link" v-b-toggle="'automation-pages'">
            <img class="menu-icon" src="../../assets/images/svg_icons/automatic.svg" alt="menu icon"><span class="menu-title">Automations</span><i class="menu-arrow"></i>
          </span>
          <b-collapse id="automation-pages">
            <ul class="nav flex-column sub-menu">
              <li class="nav-item"><router-link class="nav-link" to="/upsell"><span class="menu-title m-l-25">Upsell </span></router-link></li>
              <li class="nav-item"><router-link class="nav-link" to="/auto-draft"><span class="menu-title m-l-25">Auto Draft </span></router-link></li>
            </ul>
          </b-collapse>
        </li>

        <li class="nav-item">
          <span class="nav-link" v-b-toggle="'material-stocks'">
            <img class="menu-icon" src="../../assets/images/svg_icons/todo_list.svg" alt="menu icon"><span class="menu-title">Material Stocks</span><i class="menu-arrow"></i>
          </span>
          <b-collapse id="material-stocks">
            <ul class="nav flex-column sub-menu">
              <li class="nav-item"><router-link class="nav-link" to="/material-stocks/records"><span class="menu-title m-l-25">Material Stocks </span></router-link></li>
              <li class="nav-item"><router-link class="nav-link" to="/material-stocks/items"><span class="menu-title m-l-25">Material Items</span></router-link></li>
            </ul>
          </b-collapse>
        </li>


    <li class="nav-item">
          <span class="nav-link" v-b-toggle="'exports'">
            <img class="menu-icon" src="../../assets/images/svg_icons/download.svg" alt="menu icon"><span class="menu-title">Exports</span><i class="menu-arrow"></i>
          </span>
          <b-collapse id="exports">
            <ul class="nav flex-column sub-menu">
              <li class="nav-item"><router-link class="nav-link" to="/exports/export-customer-data"><span class="menu-title m-l-25">For Facebook </span></router-link></li>
            </ul>
          </b-collapse>
        </li>


        <li class="nav-item">
          <span class="nav-link" v-b-toggle="'sample-pages'">
            <img class="menu-icon" src="../../assets/images/svg_icons/services.svg" alt="menu icon"><span class="menu-title">Settings</span><i class="menu-arrow"></i>
          </span>
          <b-collapse id="sample-pages">
            <ul class="nav flex-column sub-menu">
              <li class="nav-item m-l-25"><router-link class="nav-link" to="/404/">Personal Settings ❌</router-link></li>
              <li class="nav-item m-l-25"><router-link class="nav-link" to="/404/">Store Settings ❌</router-link></li>
              <li class="nav-item m-l-25"><router-link class="nav-link" to="/404/">DHL Settings ❌</router-link></li>
              <!-- <li class="nav-item m-l-25"><router-link class="nav-link" to="/settings/customize-email-notification">Dev Test</router-link></li> -->
            </ul>
          </b-collapse>
        </li>
        <li class="nav-item"><router-link class="nav-link" to="/404/"><img class="menu-icon" src="../../assets/images/svg_icons/conference_call.svg" alt="menu icon"><span class="menu-title">Manage Employees</span></router-link></li>
        <!-- <li class="nav-item">
          <span class="nav-link" v-b-toggle="'sample-pages'">
            <img class="menu-icon" src="../../assets/images/menu_icons/08.png" alt="menu icon"><span class="menu-title">Settings</span><i class="menu-arrow"></i>
          </span>
          <b-collapse id="sample-pages">
            <ul class="nav flex-column sub-menu">
              <li class="nav-item"><router-link class="nav-link" to="/login/">login</router-link></li>
              <li class="nav-item"><router-link class="nav-link" to="/register/">register</router-link></li>
              <li class="nav-item"><router-link class="nav-link" to="/404/">404</router-link></li>
              <li class="nav-item"><router-link class="nav-link" to="/500/">500</router-link></li>
            </ul>
          </b-collapse>
        </li>
        <li class="nav-item">
          <span class="nav-link" v-b-toggle="'ui-components'">
            <img class="menu-icon" src="../../assets/images/menu_icons/03.png" alt="menu icon"><span class="menu-title">UI Components</span><i class="menu-arrow"></i>
          </span>
          <b-collapse id="ui-components">
            <ul class="nav flex-column sub-menu">
              <li class="nav-item"><router-link class="nav-link" to="/alerts/">Alerts</router-link></li>
              <li class="nav-item"><router-link class="nav-link" to="/buttons/">Button</router-link></li>
              <li class="nav-item"><router-link class="nav-link" to="/badges/">Badges</router-link></li>
              <li class="nav-item"><router-link class="nav-link" to="/breadcrumbs/">Breadcrumbs</router-link></li>
              <li class="nav-item"><router-link class="nav-link" to="/carousel/">Carousel</router-link></li>
              <li class="nav-item"><router-link class="nav-link" to="/dropdowns/">Dropdowns</router-link></li>
              <li class="nav-item"><router-link class="nav-link" to="/typography/">Typography</router-link></li>
              <li class="nav-item"><router-link class="nav-link" to="/paginations/">Paginations</router-link></li>
              <li class="nav-item"><router-link class="nav-link" to="/tooltips/">Tooltips</router-link></li>
              <li class="nav-item"><router-link class="nav-link" to="/progress/">Progress</router-link></li>
              <li class="nav-item"><router-link class="nav-link" to="/tabs/">Tabs</router-link></li>
              <li class="nav-item"><router-link class="nav-link" to="/modals/">Modals</router-link></li>
            </ul>
          </b-collapse>
        </li>
        <li class="nav-item"><router-link class="nav-link" to="/tables/"><img class="menu-icon" src="../../assets/images/menu_icons/06.png" alt="menu icon"><span class="menu-title">Tables</span></router-link></li>
        <li class="nav-item"><router-link class="nav-link" to="/icons/"><img class="menu-icon" src="../../assets/images/menu_icons/07.png" alt="menu icon"><span class="menu-title">Icons</span></router-link></li>
        <li class="nav-item"><router-link class="nav-link" to="/forms/"><img class="menu-icon" src="../../assets/images/menu_icons/04.png" alt="menu icon"><span class="menu-title">Forms</span></router-link></li> -->
      </ul>
    </nav>

    <file-uploader-widget />
  </section>

</template>

<script lang="js">
import FileUploaderWidget from '../common/file-uploader-widget.vue'
export default {
  name: 'app-sidebar',
  components: {FileUploaderWidget},
  computed: {
    loggedInUser(){
      return this.$store.state.auth.user;
    }
  }
}
</script>

<style scoped lang="scss">
.app-sidebar {
   background-color:rgb(46, 53, 66);
   position: relative;
}
</style>
